module.exports = __webpack_public_path__ + "fonts/4b658767da6bd92ce2addb3ce512784d.eot";